angular
	.module 'App.Repository'

.factory 'CouponsRepository', ['BaseRepository', (BaseRepository) ->
	class CouponsRepository extends BaseRepository
		@resource = '/coupons'
		@isRestricted = true

	return new CouponsRepository
]
.factory 'CouponsTypeRepository', ['BaseRepository', (BaseRepository) ->
	class CouponsTypeRepository extends BaseRepository
		@resource = '/coupon_types'
		@isRestricted = true

	return new CouponsTypeRepository
]


